import axiosApi from "@/lib/axios"

const profile = {
    namespaced: true,
    strict: true,
    state: {
        draft: null,
        profile: null,
    },
    mutations: {
        SET_DRAFT(state, payload) {
            state.draft = payload
        },
        SET_PROFILE(state, payload) {
            state.profile = payload
        },
    },
    actions: {
        update({ commit }, body) {
            return new Promise((resolve, reject) => {
                axiosApi.post('/users/update', body, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                })
                    .then(response => resolve(response.data))
                    .catch((err) => {
                        console.error('Terjadi kesalahan ketika mengubah data user: ', err)
                        reject(err)
                    })
            })
        },
        getProfile({ commit }, params = null) {
            return new Promise((resolve, reject) => {
            const url = params ? `/data-saya/profile?${new URLSearchParams(params).toString()}` : '/data-saya/profile';
            axiosApi.get(url)
                .then((response) => {
                resolve(response.data);
                })
                .catch(err => reject(err));
            });
        }
    },
}

export default profile